export default "/alerts.d449e10d-3e7662.png";